import * as React from "react";

import "./form.scss";

import {cbc}   from "@Common/react/callback-chain";
import {cs}    from "@Common/react/chain-services";
import {csArr} from "@Common/react/cs-arr";
import {AndType}   from "./field-types/and-type";
import {RangeType} from "./field-types/range-type";
import {TreeType}  from "./field-types/tree-type/tree-type";
import {CheckboxType} from "./field-types/checkbox-type"

export const Form = ({config, state, next}) => cs(
    ["controls", (_, next) => csArr(
        Object.keys(config).map((key) => (next) => cbc([
            (_, next) => {
                const fieldConfig = config[key];
                return targetTypes[fieldConfig.targetType]({fieldConfig, state, key, next});
            },
            (c) => {
                const fieldConfig = config[key];
                return next({
                    label: fieldConfig.labelForUser,
                    ...c,
                });
            },
        ])),
        next,
    )],
    ({controls}) => next({
        invalid: controls.find((c) => c.invalid),
        highlightErrors: () => controls.find((c) => c.invalid && c.highlightErrors)?.highlightErrors(),
        render: ({showErrors}) => (
            <div className="form-7d0">
                {controls.map((line, i) => (
                    <div className="line" key={i}>
                        <div className="label" style={{top: line.labelTop}} xd-qa-type="label" xd-qa-name={"Demographics Search "+line.label}>
                            {line.label}
                        </div>
                        <div className="controls">
                            {line.controls({showErrors})}
                        </div>
                    </div>
                ))}
            </div>
        ),
    }),
);

const targetTypes = {
    "rangeType"   : RangeType,
    "andType"     : AndType,
    "checkboxType": CheckboxType,
    "treeType"    : TreeType,
};

